// `IsCallable` abstract operation
// https://tc39.es/ecma262/#sec-iscallable
module.exports = function (argument) {
  return typeof argument == 'function';
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js-pure/internals/is-callable.js
// module id = 9
// module chunks = 0 1